export const commonTranslations = {
  en: {
    app: {
      name: "Finanzly",
      tagline: "Financial tools for a prosperous future",
    },
    common: {
      calculate: "Calculate",
      results: "Results",
      exportResults: "Export Results",
      loading: "Loading...",
      premium: "Premium",
      loginRequired: "Login required",
      signInRequired: "Sign in required",
      error: "Error",
      success: "Success",
      cancel: "Cancel",
      confirm: "Confirm",
      save: "Save",
      edit: "Edit",
      delete: "Delete",
      create: "Create",
      update: "Update",
      submit: "Submit",
      reset: "Reset",
      clear: "Clear",
      search: "Search",
      filter: "Filter",
      sort: "Sort",
      export: "Export",
      import: "Import",
      download: "Download",
      upload: "Upload",
      yes: "Yes",
      no: "No",
      ok: "OK",
      close: "Close",
      back: "Back",
      backToResources: "Back to Resources",
      next: "Next",
      previous: "Previous",
      first: "First",
      last: "Last",
      page: "Page",
      of: "of",
      total: "Total",
      selected: "Selected",
      all: "All",
      none: "None",
      other: "Other",
      more: "More",
      less: "Less",
      note: "Note",
      show: "Show",
      hide: "Hide",
      view: "View",
      copy: "Copy",
      paste: "Paste",
      cut: "Cut",
      undo: "Undo",
      redo: "Redo",
      refresh: "Refresh",
      reload: "Reload",
      print: "Print",
      share: "Share",
      settings: "Settings",
      help: "Help",
      about: "About",
      contact: "Contact",
      privacy: "Privacy",
      terms: "Terms",
      checking: "Checking",
      cookies: "Cookies",
      language: "Language",
      theme: "Theme",
      light: "Light",
      dark: "Dark",
      auto: "Auto",
      name: "Name",
      email: "Email",
      password: "Password",
      username: "Username",
      phone: "Phone",
      address: "Address",
      city: "City",
      country: "Country",
      date: "Date",
      time: "Time",
      amount: "Amount",
      price: "Price",
      takeHomePay: "Take Home Pay",
      netSalary: "Net Salary",
      grossSalary: "Gross Salary",
      afterTaxes: "After Taxes",
      salaryCalculator: "Salary Calculator",
      currency: "Currency",
      status: "Status",
      active: "Active",
      inactive: "Inactive",
      enabled: "Enabled",
      disabled: "Disabled",
      public: "Public",
      private: "Private",
      draft: "Draft",
      published: "Published",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      completed: "Completed",
      failed: "Failed",
      cancelled: "Cancelled",
      expired: "Expired",
      new: "New",
      recent: "Recent",
      popular: "Popular",
      featured: "Featured",
      recommended: "Recommended",
      trending: "Trending",
      top: "Top",
      bottom: "Bottom",
      left: "Left",
      right: "Right",
      center: "Center",
      start: "Start",
      end: "End",
      home: "Home",
      dashboard: "Dashboard",
      profile: "Profile",
      account: "Account",
      notifications: "Notifications",
      messages: "Messages",
      inbox: "Inbox",
      sent: "Sent",
      drafts: "Drafts",
      trash: "Trash",
      archive: "Archive",
      favorites: "Favorites",
      bookmarks: "Bookmarks",
      history: "History",
      comingSoon: "Coming Soon",
      generatedOn: "Generated on",
    },
    auth: {
      login: "Login",
      signUp: "Sign Up",
      signup: "Sign Up",
      tryForFree: "Try for free",
      signOut: "Sign out",
      modal: {
        loginTitle: "Welcome Back",
        signupTitle: "Create Account",
        loginDescription: "Sign in to your account to continue",
        signupDescription: "Create a new account to get started",
        email: "Email",
        password: "Password",
        enterEmail: "Enter your email",
        enterPassword: "Enter your password",
        signIn: "Sign In",
        createAccount: "Create Account",
        loading: "Loading...",
        continueWithGoogle: "Continue with Google",
        continueWithMicrosoft: "Continue with Microsoft",
        continueWithApple: "Continue with Apple",
        orContinueWithEmail: "Or continue with email",
        welcomeBack: "Welcome back!",
        signInSuccess: "You have been signed in successfully.",
        accountCreated: "Account created!",
        accountCreatedSuccess: "Your account has been created successfully.",
        welcome: "Welcome!",
        authError: "Authentication Error",
        switchToSignup: "Don't have an account?",
        switchToLogin: "Already have an account?",
        signUpLink: "Sign up",
        loginLink: "Log in",
        continueExploring: "Continue Exploring",
        forgotPassword: "Forgot password?",
      },
      passwordReset: {
        title: "Reset Password",
        description: "Enter your email address to receive a password reset link",
        emailPlaceholder: "Enter your email address",
        sendResetEmail: "Send Reset Email",
        successTitle: "Email Sent!",
        successMessage: "We've sent a password reset link to your email address. Please check your inbox and follow the instructions.",
        backToLogin: "Back to Login",
        checkSpam: "Don't forget to check your spam/junk folder if you don't see the email.",
      },
      verification: {
        title: "Verify Your Email",
        subtitle: "We've sent a verification email to your address",
        description: "Please check your email and click the verification link to activate your account. You won't be able to access the application until your email is verified.",
        checkEmail: "Check your email for a verification link",
        resendButton: "Resend verification email",
        resendSuccess: "Verification email sent successfully!",
        resendError: "Error sending verification email. Please try again.",
        verificationSuccess: "Email verified successfully! You can now access the application.",
        verificationError: "Invalid or expired verification link.",
        emailNotVerified: "Please verify your email address before accessing the application.",
        goToLogin: "Go to Login",
        emailVerified: "Email Verified!",
        tabWillClose: "This tab will close automatically in a moment.",
        pleaseCloseTab: "If the tab doesn't close automatically, please close it manually.",
        closeTab: "Close Tab",
        refreshStatus: "Reload Page",
        stillNotVerified: "Email is still not verified. Please check your email and click the verification link.",
        refreshError: "Error checking verification status. Please try again.",
        enterPasswordToCheck: "Please enter your password to check your account verification status",
        verifyEmailTitle: "Verify Your Email",
        verifyEmailMessage: "Please verify your email address to continue using Finanzly. We've sent a verification link to your email.",
        emailSentTo: "Verification email sent to",
        checkVerification: "I've verified my email",
        resendEmail: "Resend verification email",
        resendIn: "Resend in",
        sending: "Sending...",
        checkSpam: "Don't forget to check your spam/junk folder if you don't see the email.",
        emailSent: "Verification email sent",
        checkInbox: "Please check your inbox and click the verification link.",
        error: "Error",
        genericError: "An error occurred. Please try again.",
        notVerifiedYet: "Email not verified yet",
        pleaseCheck: "Please check your email and click the verification link.",
        success: "Email verified successfully!",
        welcomeMessage: "Welcome to Finanzly! You can now access all features.",
      },
      errors: {
        googleEmailExists:
          "This email is already registered with Google. Please use Google login to access your account.",
        emailAlreadyInUse:
          "This email address is already registered. Please try signing in instead or use a different email.",
        weakPassword: "Password should be at least 6 characters long.",
        invalidEmail: "Please enter a valid email address.",
        userNotFound: "No account found with this email address.",
        wrongPassword: "Invalid email or password.",
        invalidCredential: "Invalid email or password.",
        emailNotVerified: "Please verify your email address before signing in.",
        default: "An error occurred during authentication. Please try again.",
        passwordResetEmailNotFound: "No account found with this email address.",
        passwordResetTooManyRequests: "Too many password reset requests. Please wait before trying again.",
        passwordResetError: "Error sending password reset email. Please try again.",
      },
    },
    nav: {
      home: "Home",
      tools: "Tools",
      resources: "Resources",
      pricing: "Pricing",
    },
    language: {
      title: "Language",
      select: "Select language",
    },
    pricing: {
      title: "Choose Your Plan",
      subtitle: "Select the perfect plan for your financial journey",
      loginRequired: "Login Required",
      loginMessage: "Please log in to view pricing options and manage your subscription.",
      profile: {
        title: "My Profile",
        description: "Manage your account settings and subscription",
        accessDenied: "Access Denied",
        loginRequired: "Please log in to access your profile",
        accountInfo: {
          title: "Account Information",
          name: "Name",
          email: "Email",
          memberSince: "Member since",
          noName: "No name set",
          unknown: "Unknown",
        },
        subscription: {
          title: "Subscription",
          status: "Status",
          plan: "Plan",
          subscriptionId: "Subscription ID",
          active: "Active",
          inactive: "Inactive",
          cancelled: "Cancelled",
          freePlan: "Free Plan",
          premiumPlan: "Premium Plan",
          cancelButton: "Cancel Subscription",
          upgradeButton: "Upgrade to Premium",
          reactivateButton: "Reactivate Subscription",
          endsOn: "Ends on",
          cancelledNote: "Your subscription has been cancelled and will end on",
          reactivateSuccess: "Subscription Reactivated",
          reactivateSuccessDescription: "Your subscription has been successfully reactivated.",
          reactivateError: "Reactivation Failed",
          reactivateErrorDescription: "We couldn't reactivate your subscription. Please try again or contact support.",
          cancelSuccess: "Subscription Cancelled",
          cancelSuccessDescription: "Your subscription will be cancelled at the end of the current billing period.",
          cancelError: "Cancellation Failed",
          cancelErrorDescription: "We couldn't cancel your subscription. Please try again or contact support.",
          cancelDialog: {
            title: "Cancel Subscription",
            description: "Are you sure you want to cancel your subscription? You'll continue to have access until the end of your current billing period.",
            confirm: "Yes, Cancel Subscription",
          },
        },
        billing: {
          title: "Billing Information",
          description: "Manage your billing details and payment methods",
          activeSubscription: "You have an active subscription. Billing is handled securely through Stripe.",
          noActiveSubscription: "You don't have an active subscription. Upgrade to access premium features.",
        },
        security: {
          title: "Security",
          changePassword: "Change Password",
          changePasswordDescription: "Update your account password",
          changePasswordModal: {
            title: "Change Password",
            currentPassword: "Current Password",
            newPassword: "New Password",
            confirmPassword: "Confirm New Password",
            cancel: "Cancel",
            change: "Change Password",
            success: "Password Changed",
            successDescription: "Your password has been changed successfully.",
            error: "Change Failed",
            passwordsDontMatch: "New passwords don't match",
            weakPassword: "Password must be at least 6 characters long",
            incorrectPassword: "Current password is incorrect",
          },
        },
      },
    },
    protected: {
      loginRequired: "Sign in Required",
      loginMessage: "Please sign in to access this premium content",
      subscriptionRequired: "Premium Subscription Required",
      subscriptionMessage:
        "Upgrade to premium to access this exclusive content and advanced features",
      emailVerificationRequired: "Email Verification Required",
    },
  },
  es: {
    app: {
      name: "Finanzly",
      tagline: "Herramientas financieras para un futuro próspero",
    },
    common: {
      calculate: "Calcular",
      results: "Resultados",
      exportResults: "Exportar Resultados",
      loading: "Cargando...",
      premium: "Premium",
      loginRequired: "Inicio de sesión requerido",
      signInRequired: "Inicio de sesión requerido",
      error: "Error",
      success: "Éxito",
      cancel: "Cancelar",
      confirm: "Confirmar",
      save: "Guardar",
      edit: "Editar",
      delete: "Eliminar",
      create: "Crear",
      update: "Actualizar",
      submit: "Enviar",
      reset: "Restablecer",
      clear: "Limpiar",
      search: "Buscar",
      filter: "Filtrar",
      sort: "Ordenar",
      export: "Exportar",
      import: "Importar",
      download: "Descargar",
      upload: "Subir",
      yes: "Sí",
      no: "No",
      ok: "OK",
      close: "Cerrar",
      back: "Atrás",
      backToResources: "Volver a Recursos",
      next: "Siguiente",
      previous: "Anterior",
      first: "Primero",
      last: "Último",
      page: "Página",
      of: "de",
      total: "Total",
      selected: "Seleccionado",
      all: "Todo",
      none: "Ninguno",
      other: "Otro",
      more: "Más",
      less: "Menos",
      note: "Nota",
      show: "Mostrar",
      hide: "Ocultar",
      view: "Ver",
      copy: "Copiar",
      paste: "Pegar",
      cut: "Cortar",
      undo: "Deshacer",
      redo: "Rehacer",
      refresh: "Actualizar",
      reload: "Recargar",
      print: "Imprimir",
      share: "Compartir",
      settings: "Configuración",
      help: "Ayuda",
      about: "Acerca de",
      contact: "Contacto",
      privacy: "Privacidad",
      terms: "Términos",
      checking: "Verificando",
      cookies: "Cookies",
      language: "Idioma",
      theme: "Tema",
      light: "Claro",
      dark: "Oscuro",
      auto: "Automático",
      name: "Nombre",
      email: "Correo electrónico",
      password: "Contraseña",
      username: "Nombre de usuario",
      phone: "Teléfono",
      address: "Dirección",
      city: "Ciudad",
      country: "País",
      date: "Fecha",
      time: "Hora",
      amount: "Cantidad",
      price: "Precio",
      takeHomePay: "Salario Neto",
      netSalary: "Salario Neto",
      grossSalary: "Salario Bruto",
      afterTaxes: "Después de Impuestos",
      salaryCalculator: "Calculadora de Salario",
      currency: "Moneda",
      status: "Estado",
      active: "Activo",
      inactive: "Inactivo",
      enabled: "Habilitado",
      disabled: "Deshabilitado",
      public: "Público",
      private: "Privado",
      draft: "Borrador",
      published: "Publicado",
      pending: "Pendiente",
      approved: "Aprobado",
      rejected: "Rechazado",
      completed: "Completado",
      failed: "Fallido",
      cancelled: "Cancelado",
      expired: "Expirado",
      new: "Nuevo",
      recent: "Reciente",
      popular: "Popular",
      featured: "Destacado",
      recommended: "Recomendado",
      trending: "Tendencia",
      top: "Superior",
      bottom: "Inferior",
      left: "Izquierda",
      right: "Derecha",
      center: "Centro",
      start: "Inicio",
      end: "Fin",
      home: "Inicio",
      dashboard: "Panel de control",
      profile: "Perfil",
      account: "Cuenta",
      notifications: "Notificaciones",
      messages: "Mensajes",
      inbox: "Bandeja de entrada",
      sent: "Enviados",
      drafts: "Borradores",
      trash: "Papelera",
      archive: "Archivo",
      favorites: "Favoritos",
      bookmarks: "Marcadores",
      history: "Historial",
      comingSoon: "Próximamente",
      generatedOn: "Generado el",
    },
    auth: {
      login: "Iniciar Sesión",
      signUp: "Registrarse",
      signup: "Registrarse",
      tryForFree: "Prueba gratis",
      signOut: "Cerrar sesión",
      modal: {
        loginTitle: "Bienvenido de Nuevo",
        signupTitle: "Crear Cuenta",
        loginDescription: "Inicia sesión en tu cuenta para continuar",
        signupDescription: "Crea una nueva cuenta para comenzar",
        email: "Correo Electrónico",
        password: "Contraseña",
        enterEmail: "Ingresa tu correo electrónico",
        enterPassword: "Ingresa tu contraseña",
        signIn: "Iniciar Sesión",
        createAccount: "Crear Cuenta",
        loading: "Cargando...",
        continueWithGoogle: "Continuar con Google",
        continueWithMicrosoft: "Continuar con Microsoft",
        continueWithApple: "Continuar con Apple",
        orContinueWithEmail: "O continúa con correo electrónico",
        welcomeBack: "¡Bienvenido de nuevo!",
        signInSuccess: "Has iniciado sesión exitosamente.",
        accountCreated: "¡Cuenta creada!",
        accountCreatedSuccess: "Tu cuenta ha sido creada exitosamente.",
        welcome: "¡Bienvenido!",
        authError: "Error de Autenticación",
        switchToSignup: "¿No tienes una cuenta?",
        switchToLogin: "¿Ya tienes una cuenta?",
        signUpLink: "Regístrate",
        loginLink: "Inicia sesión",
        continueExploring: "Continuar Explorando",
        forgotPassword: "¿Olvidaste tu contraseña?",
      },
      passwordReset: {
        title: "Restablecer Contraseña",
        description: "Ingresa tu dirección de correo electrónico para recibir un enlace de restablecimiento de contraseña",
        emailPlaceholder: "Ingresa tu correo electrónico",
        sendResetEmail: "Enviar Correo de Restablecimiento",
        successTitle: "¡Correo Enviado!",
        successMessage: "Hemos enviado un enlace de restablecimiento de contraseña a tu correo electrónico. Por favor revisa tu bandeja de entrada y sigue las instrucciones.",
        backToLogin: "Volver al Inicio de Sesión",
        checkSpam: "No olvides revisar tu carpeta de spam/correo no deseado si no ves el correo.",
      },
      verification: {
        title: "Verifica Tu Correo Electrónico",
        subtitle: "Hemos enviado un correo de verificación a tu dirección",
        description: "Por favor revisa tu correo electrónico y haz clic en el enlace de verificación para activar tu cuenta. No podrás acceder a la aplicación hasta que tu correo esté verificado.",
        checkEmail: "Revisa tu correo electrónico para encontrar el enlace de verificación",
        resendButton: "Reenviar correo de verificación",
        resendSuccess: "¡Correo de verificación enviado exitosamente!",
        resendError: "Error al enviar el correo de verificación. Por favor intenta de nuevo.",
        verificationSuccess: "¡Correo verificado exitosamente! Ahora puedes acceder a la aplicación.",
        verificationError: "Enlace de verificación inválido o expirado.",
        emailNotVerified: "Por favor verifica tu dirección de correo electrónico antes de acceder a la aplicación.",
        goToLogin: "Ir al Inicio de Sesión",
        emailVerified: "¡Correo Verificado!",
        tabWillClose: "Esta pestaña se cerrará automáticamente en un momento.",
        pleaseCloseTab: "Si la pestaña no se cierra automáticamente, por favor ciérrala manualmente.",
        closeTab: "Cerrar Pestaña",
        refreshStatus: "Recargar página",
        stillNotVerified: "El correo aún no está verificado. Por favor revisa tu correo y haz clic en el enlace de verificación.",
        refreshError: "Error al verificar el estado de verificación. Por favor intenta de nuevo.",
        enterPasswordToCheck: "Por favor, introduce tu contraseña para verificar el estado de tu cuenta",
        verifyEmailTitle: "Verifica Tu Correo Electrónico",
        verifyEmailMessage: "Por favor verifica tu dirección de correo electrónico para continuar usando Finanzly. Hemos enviado un enlace de verificación a tu correo.",
        emailSentTo: "Correo de verificación enviado a",
        checkVerification: "Ya verifiqué mi correo",
        resendEmail: "Reenviar correo de verificación",
        resendIn: "Reenviar en",
        sending: "Enviando...",
        checkSpam: "No olvides revisar tu carpeta de spam/correo no deseado si no ves el correo.",
        emailSent: "Correo de verificación enviado",
        checkInbox: "Por favor revisa tu bandeja de entrada y haz clic en el enlace de verificación.",
        error: "Error",
        genericError: "Ocurrió un error. Por favor intenta de nuevo.",
        notVerifiedYet: "Correo aún no verificado",
        pleaseCheck: "Por favor revisa tu correo electrónico y haz clic en el enlace de verificación.",
        success: "¡Correo verificado exitosamente!",
        welcomeMessage: "¡Bienvenido a Finanzly! Ahora puedes acceder a todas las funciones.",
      },
      errors: {
        googleEmailExists:
          "Este correo electrónico ya está registrado con Google. Por favor usa el inicio de sesión de Google para acceder a tu cuenta.",
        emailAlreadyInUse:
          "Esta dirección de correo electrónico ya está registrada. Por favor intenta iniciar sesión o usa un correo electrónico diferente.",
        weakPassword: "La contraseña debe tener al menos 6 caracteres.",
        invalidEmail:
          "Por favor ingresa una dirección de correo electrónico válida.",
        userNotFound:
          "No se encontró ninguna cuenta con esta dirección de correo electrónico.",
        wrongPassword: "Correo electrónico o contraseña incorrectos.",
        invalidCredential: "Correo electrónico o contraseña incorrectos.",
        emailNotVerified: "Por favor verifica tu dirección de correo electrónico antes de iniciar sesión.",
        default:
          "Ocurrió un error durante la autenticación. Por favor intenta de nuevo.",
        passwordResetEmailNotFound: "No se encontró ninguna cuenta con esta dirección de correo electrónico.",
        passwordResetTooManyRequests: "Demasiadas solicitudes de restablecimiento de contraseña. Por favor espera antes de intentar de nuevo.",
        passwordResetError: "Error al enviar el correo de restablecimiento de contraseña. Por favor intenta de nuevo.",
      },
    },
    nav: {
      home: "Inicio",
      tools: "Herramientas",
      resources: "Recursos",
      pricing: "Precios",
    },
    language: {
      title: "Idioma",
      select: "Seleccionar idioma",
    },
    pricing: {
      title: "Elige tu Plan",
      subtitle: "Selecciona el plan perfecto para tu viaje financiero",
      loginRequired: "Inicia sesión para continuar",
      loginMessage:
        "Por favor inicia sesión para ver nuestros planes de precios y suscribirte",
      profile: {
        title: "Mi Perfil",
        description: "Gestiona la configuración de tu cuenta y suscripción",
        accessDenied: "Acceso Denegado",
        loginRequired: "Por favor, inicia sesión para acceder a tu perfil",
        accountInfo: {
          title: "Información de la Cuenta",
          name: "Nombre",
          email: "Correo Electrónico",
          memberSince: "Miembro desde",
          noName: "Sin nombre establecido",
          unknown: "Desconocido",
        },
        subscription: {
          title: "Suscripción",
          status: "Estado",
          plan: "Plan",
          subscriptionId: "ID de Suscripción",
          active: "Activa",
          inactive: "Inactiva",
          cancelled: "Cancelada",
          freePlan: "Plan Gratuito",
          premiumPlan: "Plan Premium",
          cancelButton: "Cancelar Suscripción",
          upgradeButton: "Actualizar a Premium",
          reactivateButton: "Reactivar Suscripción",
          endsOn: "Finaliza el",
          cancelledNote: "Tu suscripción ha sido cancelada y finalizará el",
          reactivateSuccess: "Suscripción Reactivada",
          reactivateSuccessDescription: "Tu suscripción ha sido reactivada exitosamente.",
          reactivateError: "Error al Reactivar",
          reactivateErrorDescription: "No pudimos reactivar tu suscripción. Inténtalo de nuevo o contacta con soporte.",
          cancelSuccess: "Suscripción Cancelada",
          cancelSuccessDescription: "Tu suscripción será cancelada al final del período de facturación actual.",
          cancelError: "Error al Cancelar",
          cancelErrorDescription: "No pudimos cancelar tu suscripción. Inténtalo de nuevo o contacta con soporte.",
          cancelDialog: {
            title: "Cancelar Suscripción",
            description: "¿Estás seguro de que quieres cancelar tu suscripción? Seguirás teniendo acceso hasta el final de tu período de facturación actual.",
            confirm: "Sí, Cancelar Suscripción",
          },
        },
        billing: {
          title: "Información de Facturación",
          description: "Gestiona tus detalles de facturación y métodos de pago",
          activeSubscription: "Tienes una suscripción activa. La facturación se gestiona de forma segura a través de Stripe.",
          noActiveSubscription: "No tienes una suscripción activa. Actualízate para acceder a funciones premium.",
        },
        security: {
          title: "Seguridad",
          changePassword: "Cambiar Contraseña",
          changePasswordDescription: "Actualiza la contraseña de tu cuenta",
          changePasswordModal: {
            title: "Cambiar Contraseña",
            currentPassword: "Contraseña Actual",
            newPassword: "Nueva Contraseña",
            confirmPassword: "Confirmar Nueva Contraseña",
            cancel: "Cancelar",
            change: "Cambiar Contraseña",
            success: "Contraseña Cambiada",
            successDescription: "Tu contraseña ha sido cambiada exitosamente.",
            error: "Error al Cambiar",
            passwordsDontMatch: "Las nuevas contraseñas no coinciden",
            weakPassword: "La contraseña debe tener al menos 6 caracteres",
            incorrectPassword: "La contraseña actual es incorrecta",
          },
        },
      },
    },
    protected: {
      loginRequired: "Inicio de sesión requerido",
      loginMessage:
        "Por favor inicia sesión para acceder a este contenido premium",
      subscriptionRequired: "Suscripción Premium Requerida",
      subscriptionMessage:
        "Actualiza a premium para acceder a este contenido exclusivo y funciones avanzadas",
      emailVerificationRequired: "Verificación de Email Requerida",
    },
  },
  fr: {
    app: {
      name: "Finanzly",
      tagline: "Outils financiers pour un avenir prospère",
    },
    common: {
      calculate: "Calculer",
      results: "Résultats",
      exportResults: "Exporter les résultats",
      loading: "Chargement...",
      premium: "Premium",
      loginRequired: "Connexion requise",
      signInRequired: "Connexion requise",
      error: "Erreur",
      success: "Succès",
      cancel: "Annuler",
      confirm: "Confirmer",
      save: "Enregistrer",
      edit: "Modifier",
      delete: "Supprimer",
      create: "Créer",
      update: "Mettre à jour",
      submit: "Soumettre",
      reset: "Réinitialiser",
      clear: "Effacer",
      search: "Rechercher",
      filter: "Filtrer",
      sort: "Trier",
      export: "Exporter",
      import: "Importer",
      download: "Télécharger",
      upload: "Téléverser",
      yes: "Oui",
      no: "Non",
      ok: "OK",
      close: "Fermer",
      back: "Retour",
      backToResources: "Retour aux Ressources",
      next: "Suivant",
      previous: "Précédent",
      first: "Premier",
      last: "Dernier",
      page: "Page",
      of: "de",
      total: "Total",
      selected: "Sélectionné",
      all: "Tout",
      none: "Aucun",
      other: "Autre",
      more: "Plus",
      less: "Moins",
      note: "Note",
      show: "Afficher",
      hide: "Masquer",
      view: "Voir",
      copy: "Copier",
      paste: "Coller",
      cut: "Couper",
      undo: "Annuler",
      redo: "Refaire",
      refresh: "Actualiser",
      reload: "Recharger",
      print: "Imprimer",
      share: "Partager",
      settings: "Paramètres",
      help: "Aide",
      about: "À propos",
      contact: "Contact",
      privacy: "Confidentialité",
      terms: "Conditions",
      checking: "Vérification",
      cookies: "Cookies",
      language: "Langue",
      theme: "Thème",
      light: "Clair",
      dark: "Sombre",
      auto: "Automatique",
      name: "Nom",
      email: "E-mail",
      password: "Mot de passe",
      username: "Nom d'utilisateur",
      phone: "Téléphone",
      address: "Adresse",
      city: "Ville",
      country: "Pays",
      date: "Date",
      time: "Heure",
      amount: "Montant",
      price: "Prix",
      takeHomePay: "Salaire Net",
      netSalary: "Salaire Net",
      grossSalary: "Salaire Brut",
      afterTaxes: "Après Impôts",
      salaryCalculator: "Calculateur de Salaire",
      currency: "Devise",
      status: "Statut",
      active: "Actif",
      inactive: "Inactif",
      enabled: "Activé",
      disabled: "Désactivé",
      public: "Public",
      private: "Privé",
      draft: "Brouillon",
      published: "Publié",
      pending: "En attente",
      approved: "Approuvé",
      rejected: "Rejeté",
      completed: "Terminé",
      failed: "Échoué",
      cancelled: "Annulé",
      expired: "Expiré",
      new: "Nouveau",
      recent: "Récent",
      popular: "Populaire",
      featured: "En vedette",
      recommended: "Recommandé",
      trending: "Tendance",
      top: "Haut",
      bottom: "Bas",
      left: "Gauche",
      right: "Droite",
      center: "Centre",
      start: "Début",
      end: "Fin",
      home: "Accueil",
      dashboard: "Tableau de bord",
      profile: "Profil",
      account: "Compte",
      notifications: "Notifications",
      messages: "Messages",
      inbox: "Boîte de réception",
      sent: "Envoyés",
      drafts: "Brouillons",
      trash: "Corbeille",
      archive: "Archive",
      favorites: "Favoris",
      bookmarks: "Signets",
      history: "Historique",
      comingSoon: "Bientôt disponible",
      generatedOn: "Généré le",
    },
    auth: {
      login: "Se Connecter",
      signUp: "S'inscrire",
      signup: "S'inscrire",
      tryForFree: "Essayer gratuitement",
      signOut: "Se déconnecter",
      profile: "Profil",
      modal: {
        loginTitle: "Bon Retour",
        signupTitle: "Créer un Compte",
        loginDescription: "Connectez-vous à votre compte pour continuer",
        signupDescription: "Créez un nouveau compte pour commencer",
        email: "E-mail",
        password: "Mot de Passe",
        enterEmail: "Entrez votre e-mail",
        enterPassword: "Entrez votre mot de passe",
        signIn: "Se Connecter",
        createAccount: "Créer un Compte",
        loading: "Chargement...",
        continueWithGoogle: "Continuer avec Google",
        continueWithMicrosoft: "Continuer avec Microsoft",
        continueWithApple: "Continuer avec Apple",
        orContinueWithEmail: "Ou continuer avec l'e-mail",
        welcomeBack: "Bon retour !",
        signInSuccess: "Vous vous êtes connecté avec succès.",
        accountCreated: "Compte créé !",
        accountCreatedSuccess: "Votre compte a été créé avec succès.",
        welcome: "Bienvenue !",
        authError: "Erreur d'Authentification",
        switchToSignup: "Vous n'avez pas de compte ?",
        switchToLogin: "Vous avez déjà un compte ?",
        signUpLink: "S'inscrire",
        loginLink: "Se connecter",
        continueExploring: "Continuer à Explorer",
        forgotPassword: "Mot de passe oublié ?",
      },
      passwordReset: {
        title: "Réinitialiser le Mot de Passe",
        description: "Entrez votre adresse e-mail pour recevoir un lien de réinitialisation de mot de passe",
        emailPlaceholder: "Entrez votre adresse e-mail",
        sendResetEmail: "Envoyer l'E-mail de Réinitialisation",
        successTitle: "E-mail Envoyé !",
        successMessage: "Nous avons envoyé un lien de réinitialisation de mot de passe à votre adresse e-mail. Veuillez vérifier votre boîte de réception et suivre les instructions.",
        backToLogin: "Retour à la Connexion",
        checkSpam: "N'oubliez pas de vérifier votre dossier spam/courrier indésirable si vous ne voyez pas l'e-mail.",
      },
      verification: {
        title: "Vérifiez Votre E-mail",
        subtitle: "Nous avons envoyé un e-mail de vérification à votre adresse",
        description: "Veuillez vérifier votre e-mail et cliquer sur le lien de vérification pour activer votre compte. Vous ne pourrez pas accéder à l'application tant que votre e-mail n'est pas vérifié.",
        checkEmail: "Vérifiez votre e-mail pour le lien de vérification",
        resendButton: "Renvoyer l'e-mail de vérification",
        resendSuccess: "E-mail de vérification envoyé avec succès !",
        resendError: "Erreur lors de l'envoi de l'e-mail de vérification. Veuillez réessayer.",
        verificationSuccess: "E-mail vérifié avec succès ! Vous pouvez maintenant accéder à l'application.",
        verificationError: "Lien de vérification invalide ou expiré.",
        emailNotVerified: "Veuillez vérifier votre adresse e-mail avant d'accéder à l'application.",
        goToLogin: "Aller à la Connexion",
        emailVerified: "E-mail Vérifié !",
        tabWillClose: "Cet onglet se fermera automatiquement dans un instant.",
        pleaseCloseTab: "Si l'onglet ne se ferme pas automatiquement, veuillez le fermer manuellement.",
        closeTab: "Fermer l'Onglet",
        refreshStatus: "Recharger la page",
        stillNotVerified: "L'e-mail n'est toujours pas vérifié. Veuillez vérifier votre e-mail et cliquer sur le lien de vérification.",
        refreshError: "Erreur lors de la vérification de l'état de vérification. Veuillez réessayer.",
      },
      errors: {
        googleEmailExists:
          "Cette adresse e-mail est déjà enregistrée avec Google. Veuillez utiliser la connexion Google pour accéder à votre compte.",
        emailAlreadyInUse:
          "Cette adresse e-mail est déjà enregistrée. Veuillez essayer de vous connecter ou utiliser une adresse e-mail différente.",
        weakPassword: "Le mot de passe doit contenir au moins 6 caractères.",
        invalidEmail: "Veuillez saisir une adresse e-mail valide.",
        userNotFound: "Aucun compte trouvé avec cette adresse e-mail.",
        wrongPassword: "E-mail ou mot de passe invalide.",
        invalidCredential: "E-mail ou mot de passe invalide.",
        emailNotVerified: "Veuillez vérifier votre adresse e-mail avant de vous connecter.",
        default:
          "Une erreur s'est produite lors de l'authentification. Veuillez réessayer.",
        passwordResetEmailNotFound: "Aucun compte trouvé avec cette adresse e-mail.",
        passwordResetTooManyRequests: "Trop de demandes de réinitialisation de mot de passe. Veuillez attendre avant de réessayer.",
        passwordResetError: "Erreur lors de l'envoi de l'e-mail de réinitialisation de mot de passe. Veuillez réessayer.",
      },
    },
    nav: {
      home: "Accueil",
      tools: "Outils",
      resources: "Ressources",
      pricing: "Tarifs",
    },
    language: {
      title: "Langue",
      select: "Sélectionner la langue",
    },
    pricing: {
      title: "Choisissez votre plan",
      subtitle: "Sélectionnez le plan parfait pour votre parcours financier",
      loginRequired: "Connectez-vous pour continuer",
      loginMessage:
        "Veuillez vous connecter pour voir nos plans tarifaires et vous abonner",
      profile: {
        title: "Mon Profil",
        description: "Gérez les paramètres de votre compte et votre abonnement",
        accessDenied: "Accès Refusé",
        loginRequired: "Veuillez vous connecter pour accéder à votre profil",
        accountInfo: {
          title: "Informations du Compte",
          name: "Nom",
          email: "E-mail",
          memberSince: "Membre depuis",
          noName: "Aucun nom défini",
          unknown: "Inconnu",
        },
        subscription: {
          title: "Abonnement",
          status: "Statut",
          plan: "Plan",
          subscriptionId: "ID d'Abonnement",
          active: "Actif",
          inactive: "Inactif",
          cancelled: "Annulé",
          freePlan: "Plan Gratuit",
          premiumPlan: "Plan Premium",
          cancelButton: "Annuler l'Abonnement",
          upgradeButton: "Passer au Premium",
          reactivateButton: "Réactiver l'Abonnement",
          endsOn: "Se termine le",
          cancelledNote: "Votre abonnement a été annulé et se terminera le",
          reactivateSuccess: "Abonnement Réactivé",
          reactivateSuccessDescription: "Votre abonnement a été réactivé avec succès.",
          reactivateError: "Échec de la Réactivation",
          reactivateErrorDescription: "Nous n'avons pas pu réactiver votre abonnement. Veuillez réessayer ou contacter le support.",
          cancelSuccess: "Abonnement Annulé",
          cancelSuccessDescription: "Votre abonnement sera annulé à la fin de la période de facturation actuelle.",
          cancelError: "Échec de l'Annulation",
          cancelErrorDescription: "Nous n'avons pas pu annuler votre abonnement. Veuillez réessayer ou contacter le support.",
          cancelDialog: {
            title: "Annuler l'Abonnement",
            description: "Êtes-vous sûr de vouloir annuler votre abonnement ? Vous continuerez à avoir accès jusqu'à la fin de votre période de facturation actuelle.",
            confirm: "Oui, Annuler l'Abonnement",
          },
        },
        billing: {
          title: "Informations de Facturation",
          description: "Gérez vos détails de facturation et méthodes de paiement",
          activeSubscription: "Vous avez un abonnement actif. La facturation est gérée de manière sécurisée via Stripe.",
          noActiveSubscription: "Vous n'avez pas d'abonnement actif. Passez au premium pour accéder aux fonctionnalités premium.",
        },
        security: {
          title: "Sécurité",
          changePassword: "Changer le Mot de Passe",
          changePasswordDescription: "Mettre à jour le mot de passe de votre compte",
          changePasswordModal: {
            title: "Changer le Mot de Passe",
            currentPassword: "Mot de Passe Actuel",
            newPassword: "Nouveau Mot de Passe",
            confirmPassword: "Confirmer le Nouveau Mot de Passe",
            cancel: "Annuler",
            change: "Changer le Mot de Passe",
            success: "Mot de Passe Modifié",
            successDescription: "Votre mot de passe a été modifié avec succès.",
            error: "Échec du Changement",
            passwordsDontMatch: "Les nouveaux mots de passe ne correspondent pas",
            weakPassword: "Le mot de passe doit contenir au moins 6 caractères",
            incorrectPassword: "Le mot de passe actuel est incorrect",
          },
        },
      },
    },
    protected: {
      loginRequired: "Connexion requise",
      loginMessage: "Veuillez vous connecter pour accéder à ce contenu premium",
      subscriptionRequired: "Abonnement Premium requis",
      subscriptionMessage:
        "Passez au premium pour accéder à ce contenu exclusif et aux fonctionnalités avancées",
      emailVerificationRequired: "Vérification d'E-mail Requise",
    },
  },
  de: {
    app: {
      name: "Finanzly",
      tagline: "Finanztools für eine erfolgreiche Zukunft",
    },
    common: {
      calculate: "Berechnen",
      results: "Ergebnisse",
      exportResults: "Ergebnisse exportieren",
      loading: "Wird geladen...",
      premium: "Premium",
      loginRequired: "Anmeldung erforderlich",
      signInRequired: "Anmeldung erforderlich",
      error: "Fehler",
      success: "Erfolg",
      cancel: "Abbrechen",
      confirm: "Bestätigen",
      save: "Speichern",
      edit: "Bearbeiten",
      delete: "Löschen",
      create: "Erstellen",
      update: "Aktualisieren",
      submit: "Senden",
      reset: "Zurücksetzen",
      clear: "Löschen",
      search: "Suchen",
      filter: "Filtern",
      sort: "Sortieren",
      export: "Exportieren",
      import: "Importieren",
      download: "Herunterladen",
      upload: "Hochladen",
      yes: "Ja",
      no: "Nein",
      ok: "OK",
      close: "Schließen",
      back: "Zurück",
      backToResources: "Zurück zu Ressourcen",
      next: "Weiter",
      previous: "Vorherige",
      first: "Erste",
      last: "Letzte",
      page: "Seite",
      of: "von",
      total: "Gesamt",
      selected: "Ausgewählt",
      all: "Alle",
      none: "Keine",
      other: "Andere",
      more: "Mehr",
      less: "Weniger",
      note: "Hinweis",
      show: "Anzeigen",
      hide: "Ausblenden",
      view: "Ansicht",
      copy: "Kopieren",
      paste: "Einfügen",
      cut: "Ausschneiden",
      undo: "Rückgängig",
      redo: "Wiederholen",
      refresh: "Aktualisieren",
      reload: "Neu laden",
      print: "Drucken",
      share: "Teilen",
      settings: "Einstellungen",
      help: "Hilfe",
      about: "Über",
      contact: "Kontakt",
      privacy: "Datenschutz",
      terms: "Bedingungen",
      checking: "Überprüfung",
      cookies: "Cookies",
      language: "Sprache",
      theme: "Design",
      light: "Hell",
      dark: "Dunkel",
      auto: "Automatisch",
      name: "Name",
      email: "E-Mail",
      password: "Passwort",
      username: "Benutzername",
      phone: "Telefon",
      address: "Adresse",
      city: "Stadt",
      country: "Land",
      date: "Datum",
      time: "Zeit",
      amount: "Betrag",
      price: "Preis",
      takeHomePay: "Nettolohn",
      netSalary: "Nettogehalt",
      grossSalary: "Bruttogehalt",
      afterTaxes: "Nach Steuern",
      salaryCalculator: "Gehaltsrechner",
      currency: "Währung",
      status: "Status",
      active: "Aktiv",
      inactive: "Inaktiv",
      enabled: "Aktiviert",
      disabled: "Deaktiviert",
      public: "Öffentlich",
      private: "Privat",
      draft: "Entwurf",
      published: "Veröffentlicht",
      pending: "Ausstehend",
      approved: "Genehmigt",
      rejected: "Abgelehnt",
      completed: "Abgeschlossen",
      failed: "Fehlgeschlagen",
      cancelled: "Abgebrochen",
      expired: "Abgelaufen",
      new: "Neu",
      recent: "Kürzlich",
      popular: "Beliebt",
      featured: "Empfohlen",
      recommended: "Empfohlen",
      trending: "Trending",
      top: "Oben",
      bottom: "Unten",
      left: "Links",
      right: "Rechts",
      center: "Mitte",
      start: "Start",
      end: "Ende",
      home: "Startseite",
      dashboard: "Dashboard",
      profile: "Profil",
      account: "Konto",
      notifications: "Benachrichtigungen",
      messages: "Nachrichten",
      inbox: "Posteingang",
      sent: "Gesendet",
      drafts: "Entwürfe",
      trash: "Papierkorb",
      archive: "Archiv",
      favorites: "Favoriten",
      bookmarks: "Lesezeichen",
      history: "Verlauf",
      comingSoon: "Demnächst",
      generatedOn: "Erstellt am",
    },
    auth: {
      login: "Anmelden",
      signUp: "Registrieren",
      signup: "Registrieren",
      tryForFree: "Kostenlos testen",
      signOut: "Abmelden",
      profile: "Profil",
      modal: {
        loginTitle: "Willkommen Zurück",
        signupTitle: "Konto Erstellen",
        loginDescription: "Melden Sie sich in Ihrem Konto an, um fortzufahren",
        signupDescription: "Erstellen Sie ein neues Konto, um zu beginnen",
        email: "E-Mail",
        password: "Passwort",
        enterEmail: "Geben Sie Ihre E-Mail ein",
        enterPassword: "Geben Sie Ihr Passwort ein",
        signIn: "Anmelden",
        createAccount: "Konto Erstellen",
        loading: "Laden...",
        continueWithGoogle: "Mit Google fortfahren",
        continueWithMicrosoft: "Mit Microsoft fortfahren",
        continueWithApple: "Mit Apple fortfahren",
        orContinueWithEmail: "Oder mit E-Mail fortfahren",
        welcomeBack: "Willkommen zurück!",
        signInSuccess: "Sie haben sich erfolgreich angemeldet.",
        accountCreated: "Konto erstellt!",
        accountCreatedSuccess: "Ihr Konto wurde erfolgreich erstellt.",
        welcome: "Willkommen!",
        authError: "Authentifizierungsfehler",
        switchToSignup: "Haben Sie kein Konto?",
        switchToLogin: "Haben Sie bereits ein Konto?",
        signUpLink: "Registrieren",
        loginLink: "Anmelden",
        continueExploring: "Weiter Erkunden",
        forgotPassword: "Passwort vergessen?",
      },
      passwordReset: {
        title: "Passwort Zurücksetzen",
        description: "Geben Sie Ihre E-Mail-Adresse ein, um einen Link zum Zurücksetzen des Passworts zu erhalten",
        emailPlaceholder: "Geben Sie Ihre E-Mail-Adresse ein",
        sendResetEmail: "Zurücksetzungs-E-Mail Senden",
        successTitle: "E-Mail Gesendet!",
        successMessage: "Wir haben einen Link zum Zurücksetzen des Passworts an Ihre E-Mail-Adresse gesendet. Bitte überprüfen Sie Ihren Posteingang und folgen Sie den Anweisungen.",
        backToLogin: "Zurück zur Anmeldung",
        checkSpam: "Vergessen Sie nicht, Ihren Spam-/Junk-Ordner zu überprüfen, wenn Sie die E-Mail nicht sehen.",
      },
      verification: {
        title: "Verifizieren Sie Ihre E-Mail",
        subtitle: "Wir haben eine Verifizierungs-E-Mail an Ihre Adresse gesendet",
        description: "Bitte überprüfen Sie Ihre E-Mail und klicken Sie auf den Verifizierungslink, um Ihr Konto zu aktivieren. Sie können erst auf die Anwendung zugreifen, wenn Ihre E-Mail verifiziert ist.",
        checkEmail: "Überprüfen Sie Ihre E-Mail für den Verifizierungslink",
        resendButton: "Verifizierungs-E-Mail erneut senden",
        resendSuccess: "Verifizierungs-E-Mail erfolgreich gesendet!",
        resendError: "Fehler beim Senden der Verifizierungs-E-Mail. Bitte versuchen Sie es erneut.",
        verificationSuccess: "E-Mail erfolgreich verifiziert! Sie können jetzt auf die Anwendung zugreifen.",
        verificationError: "Ungültiger oder abgelaufener Verifizierungslink.",
        emailNotVerified: "Bitte verifizieren Sie Ihre E-Mail-Adresse, bevor Sie auf die Anwendung zugreifen.",
        goToLogin: "Zur Anmeldung gehen",
        emailVerified: "E-Mail Verifiziert!",
        tabWillClose: "Dieser Tab wird in einem Moment automatisch geschlossen.",
        pleaseCloseTab: "Falls der Tab nicht automatisch geschlossen wird, schließen Sie ihn bitte manuell.",
        closeTab: "Tab Schließen",
        refreshStatus: "Seite neu laden",
        stillNotVerified: "E-Mail ist noch nicht verifiziert. Bitte überprüfen Sie Ihre E-Mail und klicken Sie auf den Verifizierungslink.",
        refreshError: "Fehler beim Überprüfen des Verifizierungsstatus. Bitte versuchen Sie es erneut.",
      },
      errors: {
        googleEmailExists:
          "Diese E-Mail-Adresse ist bereits mit Google registriert. Bitte verwenden Sie die Google-Anmeldung, um auf Ihr Konto zuzugreifen.",
        emailAlreadyInUse:
          "Diese E-Mail-Adresse ist bereits registriert. Bitte versuchen Sie sich anzumelden oder verwenden Sie eine andere E-Mail-Adresse.",
        weakPassword: "Das Passwort sollte mindestens 6 Zeichen lang sein.",
        invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
        userNotFound: "Kein Konto mit dieser E-Mail-Adresse gefunden.",
        wrongPassword: "Ungültige E-Mail oder Passwort.",
        invalidCredential: "Ungültige E-Mail oder Passwort.",
        emailNotVerified: "Bitte verifizieren Sie Ihre E-Mail-Adresse, bevor Sie sich anmelden.",
        default:
          "Ein Fehler ist bei der Authentifizierung aufgetreten. Bitte versuchen Sie es erneut.",
        passwordResetEmailNotFound: "Kein Konto mit dieser E-Mail-Adresse gefunden.",
        passwordResetTooManyRequests: "Zu viele Anfragen zum Zurücksetzen des Passworts. Bitte warten Sie, bevor Sie es erneut versuchen.",
        passwordResetError: "Fehler beim Senden der Passwort-Zurücksetzungs-E-Mail. Bitte versuchen Sie es erneut.",
      },
    },
    nav: {
      home: "Startseite",
      tools: "Werkzeuge",
      resources: "Ressourcen",
      pricing: "Preise",
    },
    language: {
      title: "Sprache",
      select: "Sprache auswählen",
    },
    pricing: {
      title: "Wählen Sie Ihren Plan",
      subtitle: "Wählen Sie den perfekten Plan für Ihre finanzielle Reise",
      loginRequired: "Anmelden um fortzufahren",
      loginMessage:
        "Bitte melden Sie sich an, um unsere Preispläne zu sehen und sich zu abonnieren",
      profile: {
        title: "Mein Profil",
        description: "Verwalten Sie Ihre Kontoeinstellungen und Ihr Abonnement",
        accessDenied: "Zugriff Verweigert",
        loginRequired: "Bitte melden Sie sich an, um auf Ihr Profil zuzugreifen",
        accountInfo: {
          title: "Kontoinformationen",
          name: "Name",
          email: "E-Mail",
          memberSince: "Mitglied seit",
          noName: "Kein Name festgelegt",
          unknown: "Unbekannt",
        },
        subscription: {
          title: "Abonnement",
          status: "Status",
          plan: "Plan",
          subscriptionId: "Abonnement-ID",
          active: "Aktiv",
          inactive: "Inaktiv",
          cancelled: "Gekündigt",
          freePlan: "Kostenloser Plan",
          premiumPlan: "Premium-Plan",
          cancelButton: "Abonnement Kündigen",
          upgradeButton: "Auf Premium Upgraden",
          reactivateButton: "Abonnement Reaktivieren",
          endsOn: "Endet am",
          cancelledNote: "Ihr Abonnement wurde gekündigt und endet am",
          reactivateSuccess: "Abonnement Reaktiviert",
          reactivateSuccessDescription: "Ihr Abonnement wurde erfolgreich reaktiviert.",
          reactivateError: "Reaktivierung Fehlgeschlagen",
          reactivateErrorDescription: "Wir konnten Ihr Abonnement nicht reaktivieren. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
          cancelSuccess: "Abonnement Gekündigt",
          cancelSuccessDescription: "Ihr Abonnement wird am Ende der aktuellen Abrechnungsperiode gekündigt.",
          cancelError: "Kündigung Fehlgeschlagen",
          cancelErrorDescription: "Wir konnten Ihr Abonnement nicht kündigen. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
          cancelDialog: {
            title: "Abonnement Kündigen",
            description: "Sind Sie sicher, dass Sie Ihr Abonnement kündigen möchten? Sie haben weiterhin Zugriff bis zum Ende Ihrer aktuellen Abrechnungsperiode.",
            confirm: "Ja, Abonnement Kündigen",
          },
        },
        billing: {
          title: "Abrechnungsinformationen",
          description: "Verwalten Sie Ihre Abrechnungsdetails und Zahlungsmethoden",
          activeSubscription: "Sie haben ein aktives Abonnement. Die Abrechnung wird sicher über Stripe abgewickelt.",
          noActiveSubscription: "Sie haben kein aktives Abonnement. Upgraden Sie, um auf Premium-Funktionen zuzugreifen.",
        },
        security: {
          title: "Sicherheit",
          changePassword: "Passwort Ändern",
          changePasswordDescription: "Aktualisieren Sie Ihr Kontopasswort",
          changePasswordModal: {
            title: "Passwort Ändern",
            currentPassword: "Aktuelles Passwort",
            newPassword: "Neues Passwort",
            confirmPassword: "Neues Passwort Bestätigen",
            cancel: "Abbrechen",
            change: "Passwort Ändern",
            success: "Passwort Geändert",
            successDescription: "Ihr Passwort wurde erfolgreich geändert.",
            error: "Änderung Fehlgeschlagen",
            passwordsDontMatch: "Die neuen Passwörter stimmen nicht überein",
            weakPassword: "Das Passwort muss mindestens 6 Zeichen lang sein",
            incorrectPassword: "Das aktuelle Passwort ist falsch",
          },
        },
      },
    },
    protected: {
      loginRequired: "Anmeldung erforderlich",
      loginMessage:
        "Bitte melden Sie sich an, um auf diesen Premium-Inhalt zuzugreifen",
      subscriptionRequired: "Premium-Abonnement erforderlich",
      subscriptionMessage:
        "Upgraden Sie auf Premium, um auf exklusive Inhalte und erweiterte Funktionen zuzugreifen",
      emailVerificationRequired: "E-Mail-Verifizierung erforderlich",
    },
  },
  hi: {
    app: {
      name: "Finanzly",
      tagline: "समृद्ध भविष्य के लिए वित्तीय उपकरण",
    },
    common: {
      calculate: "गणना करें",
      results: "परिणाम",
      exportResults: "परिणाम निर्यात करें",
      loading: "लोड हो रहा है...",
      premium: "प्रीमियम",
      loginRequired: "लॉगिन आवश्यक",
      signInRequired: "साइन इन आवश्यक",
      error: "त्रुटि",
      success: "सफलता",
      cancel: "रद्द करें",
      confirm: "पुष्टि करें",
      save: "सहेजें",
      edit: "संपादित करें",
      delete: "हटाएं",
      create: "बनाएं",
      update: "अपडेट करें",
      submit: "जमा करें",
      reset: "रीसेट करें",
      clear: "साफ़ करें",
      search: "खोजें",
      filter: "फ़िल्टर करें",
      sort: "क्रमबद्ध करें",
      export: "निर्यात करें",
      import: "आयात करें",
      download: "डाउनलोड करें",
      upload: "अपलोड करें",
      yes: "हां",
      no: "नहीं",
      ok: "ठीक",
      close: "बंद करें",
      back: "वापस",
      backToResources: "संसाधनों पर वापस जाएं",
      next: "अगला",
      previous: "पिछला",
      first: "पहला",
      last: "अंतिम",
      page: "पृष्ठ",
      of: "का",
      total: "कुल",
      selected: "चयनित",
      all: "सभी",
      none: "कोई नहीं",
      other: "अन्य",
      more: "अधिक",
      less: "कम",
      note: "नोट",
      show: "दिखाएं",
      hide: "छुपाएं",
      view: "देखें",
      copy: "कॉपी करें",
      paste: "पेस्ट करें",
      cut: "कट करें",
      undo: "पूर्ववत करें",
      redo: "फिर से करें",
      refresh: "रीफ्रेश करें",
      reload: "पुनः लोड करें",
      print: "प्रिंट करें",
      share: "साझा करें",
      settings: "सेटिंग्स",
      help: "सहायता",
      about: "के बारे में",
      contact: "संपर्क",
      privacy: "गोपनीयता",
      terms: "शर्तें",
      checking: "जांच रहे हैं",
      cookies: "कुकीज़",
      language: "भाषा",
      theme: "थीम",
      light: "उजला",
      dark: "गहरा",
      auto: "स्वचालित",
      name: "नाम",
      email: "ईमेल",
      password: "पासवर्ड",
      username: "उपयोगकर्ता नाम",
      phone: "फ़ोन",
      address: "पता",
      city: "शहर",
      country: "देश",
      date: "दिनांक",
      time: "समय",
      amount: "राशि",
      price: "मूल्य",
      takeHomePay: "वेतन के बाद कर",
      netSalary: "नेट वेतन",
      grossSalary: "सकल वेतन",
      afterTaxes: "करों के बाद",
      salaryCalculator: "वेतन कैलकुलेटर",
      currency: "मुद्रा",
      status: "स्थिति",
      active: "सक्रिय",
      inactive: "निष्क्रिय",
      enabled: "सक्षम",
      disabled: "अक्षम",
      public: "सार्वजनिक",
      private: "निजी",
      draft: "मसौदा",
      published: "प्रकाशित",
      pending: "लंबित",
      approved: "अनुमोदित",
      rejected: "अस्वीकृत",
      completed: "पूर्ण",
      failed: "असफल",
      cancelled: "रद्द",
      expired: "समाप्त",
      new: "नया",
      recent: "हाल का",
      popular: "लोकप्रिय",
      featured: "विशेष",
      recommended: "अनुशंसित",
      trending: "ट्रेंडिंग",
      top: "शीर्ष",
      bottom: "नीचे",
      left: "बाएं",
      right: "दाएं",
      center: "केंद्र",
      start: "शुरुआत",
      end: "अंत",
      home: "होम",
      dashboard: "डैशबोर्ड",
      profile: "प्रोफ़ाइल",
      account: "खाता",
      notifications: "सूचनाएं",
      messages: "संदेश",
      inbox: "इनबॉक्स",
      sent: "भेजे गए",
      drafts: "मसौदे",
      trash: "कूड़ेदान",
      archive: "संग्रह",
      favorites: "पसंदीदा",
      bookmarks: "बुकमार्क",
      history: "इतिहास",
      comingSoon: "जल्द आ रहा है",
      generatedOn: "उत्पन्न किया गया",
    },
    auth: {
      login: "लॉग इन",
      signUp: "साइन अप करें",
      signup: "साइन अप करें",
      tryForFree: "मुफ्त में आजमाएं",
      signOut: "साइन आउट",
      profile: "प्रोफाइल",
      modal: {
        loginTitle: "वापस स्वागत है",
        signupTitle: "खाता बनाएं",
        loginDescription: "जारी रखने के लिए अपने खाते में साइन इन करें",
        signupDescription: "शुरू करने के लिए एक नया खाता बनाएं",
        email: "ईमेल",
        password: "पासवर्ड",
        enterEmail: "अपना ईमेल दर्ज करें",
        enterPassword: "अपना पासवर्ड दर्ज करें",
        signIn: "साइन इन",
        createAccount: "खाता बनाएं",
        loading: "लोड हो रहा है...",
        continueWithGoogle: "Google के साथ जारी रखें",
        continueWithMicrosoft: "Microsoft के साथ जारी रखें",
        continueWithApple: "Apple के साथ जारी रखें",
        orContinueWithEmail: "या ईमेल के साथ जारी रखें",
        welcomeBack: "वापस स्वागत है!",
        signInSuccess: "आप सफलतापूर्वक साइन इन हो गए हैं।",
        accountCreated: "खाता बनाया गया!",
        accountCreatedSuccess: "आपका खाता सफलतापूर्वक बनाया गया है।",
        welcome: "स्वागत है!",
        authError: "प्रमाणीकरण त्रुटि",
        switchToSignup: "क्या आपका कोई खाता नहीं है?",
        switchToLogin: "क्या आपका पहले से खाता है?",
        signUpLink: "साइन अप",
        loginLink: "लॉग इन",
        continueExploring: "अन्वेषण जारी रखें",
        forgotPassword: "पासवर्ड भूल गए?",
      },
      passwordReset: {
        title: "पासवर्ड रीसेट करें",
        description: "पासवर्ड रीसेट लिंक प्राप्त करने के लिए अपना ईमेल पता दर्ज करें",
        emailPlaceholder: "अपना ईमेल पता दर्ज करें",
        sendResetEmail: "रीसेट ईमेल भेजें",
        successTitle: "ईमेल भेजा गया!",
        successMessage: "हमने आपके ईमेल पते पर पासवर्ड रीसेट लिंक भेजा है। कृपया अपना इनबॉक्स जांचें और निर्देशों का पालन करें।",
        backToLogin: "लॉगिन पर वापस जाएं",
        checkSpam: "यदि आपको ईमेल दिखाई नहीं दे रहा है तो अपने स्पैम/जंक फ़ोल्डर को जांचना न भूलें।",
      },
      verification: {
        title: "अपना ईमेल सत्यापित करें",
        subtitle: "हमने आपके पते पर एक सत्यापन ईमेल भेजा है",
        description: "कृपया अपना ईमेल जांचें और अपने खाते को सक्रिय करने के लिए सत्यापन लिंक पर क्लिक करें। जब तक आपका ईमेल सत्यापित नहीं होता तब तक आप एप्लिकेशन तक पहुंच नहीं पाएंगे।",
        checkEmail: "सत्यापन लिंक के लिए अपना ईमेल जांचें",
        resendButton: "सत्यापन ईमेल फिर से भेजें",
        resendSuccess: "सत्यापन ईमेल सफलतापूर्वक भेज दिया गया!",
        resendError: "सत्यापन ईमेल भेजने में त्रुटि। कृपया पुनः प्रयास करें।",
        verificationSuccess: "ईमेल सफलतापूर्वक सत्यापित हो गया! अब आप एप्लिकेशन तक पहुंच सकते हैं।",
        verificationError: "अमान्य या समाप्त हो चुका सत्यापन लिंक।",
        emailNotVerified: "एप्लिकेशन तक पहुंचने से पहले कृपया अपना ईमेल पता सत्यापित करें।",
        goToLogin: "लॉगिन पर जाएं",
        emailVerified: "ईमेल सत्यापित!",
        tabWillClose: "यह टैब एक पल में अपने आप बंद हो जाएगा।",
        pleaseCloseTab: "यदि टैब अपने आप बंद नहीं होता है, तो कृपया इसे मैन्युअल रूप से बंद करें।",
        closeTab: "टैब बंद करें",
        refreshStatus: "पेज को फिर से लोड करें",
        stillNotVerified: "ईमेल अभी भी सत्यापित नहीं है। कृपया अपना ईमेल जांचें और सत्यापन लिंक पर क्लिक करें।",
        refreshError: "सत्यापन स्थिति जांचने में त्रुटि। कृपया पुनः प्रयास करें।",
        enterPasswordToCheck: "अपने खाते की सत्यापन स्थिति जांचने के लिए कृपया अपना पासवर्ड दर्ज करें",
      },
      errors: {
        googleEmailExists:
          "यह ईमेल पता पहले से ही Google के साथ पंजीकृत है। कृपया अपने खाते तक पहुंचने के लिए Google लॉगिन का उपयोग करें।",
        emailAlreadyInUse:
          "यह ईमेल पता पहले से ही पंजीकृत है। कृपया साइन इन करने का प्रयास करें या कोई अलग ईमेल पता उपयोग करें।",
        weakPassword: "पासवर्ड कम से कम 6 अक्षर लंबा होना चाहिए।",
        invalidEmail: "कृपया एक वैध ईमेल पता दर्ज करें।",
        userNotFound: "इस ईमेल पते के साथ कोई खाता नहीं मिला।",
        wrongPassword: "अमान्य ईमेल या पासवर्ड।",
        invalidCredential: "अमान्य ईमेल या पासवर्ड।",
        emailNotVerified: "साइन इन करने से पहले कृपया अपने ईमेल पते को सत्यापित करें।",
        default: "प्रमाणीकरण के दौरान एक त्रुटि हुई। कृपया पुनः प्रयास करें।",
        passwordResetEmailNotFound: "इस ईमेल पते के साथ कोई खाता नहीं मिला।",
        passwordResetTooManyRequests: "बहुत सारे पासवर्ड रीसेट अनुरोध। कृपया पुनः प्रयास करने से पहले प्रतीक्षा करें।",
        passwordResetError: "पासवर्ड रीसेट ईमेल भेजने में त्रुटि। कृपया पुनः प्रयास करें।",
      },
    },
    nav: {
      home: "होम",
      tools: "उपकरण",
      resources: "संसाधन",
      pricing: "मूल्य निर्धारण",
    },
    language: {
      title: "भाषा",
      select: "भाषा चुनें",
    },
    pricing: {
      title: "अपना प्लान चुनें",
      subtitle: "अपनी वित्तीय यात्रा के लिए सही प्लान चुनें",
      loginRequired: "जारी रखने के लिए साइन इन करें",
      loginMessage:
        "कृपया हमारी प्राइसिंग प्लान देखने और सब्सक्राइब करने के लिए साइन इन करें",
      profile: {
        title: "मेरी प्रोफाइल",
        description: "अपनी खाता सेटिंग्स और सदस्यता प्रबंधित करें",
        accessDenied: "पहुंच अस्वीकृत",
        loginRequired: "कृपया अपनी प्रोफाइल तक पहुंचने के लिए लॉग इन करें",
        accountInfo: {
          title: "खाता जानकारी",
          name: "नाम",
          email: "ईमेल",
          memberSince: "सदस्य बनने की तारीख",
          noName: "कोई नाम सेट नहीं",
          unknown: "अज्ञात",
        },
        subscription: {
          title: "सदस्यता",
          status: "स्थिति",
          plan: "योजना",
          subscriptionId: "सदस्यता ID",
          active: "सक्रिय",
          inactive: "निष्क्रिय",
          cancelled: "रद्द",
          freePlan: "मुफ्त योजना",
          premiumPlan: "प्रीमियम योजना",
          cancelButton: "सदस्यता रद्द करें",
          upgradeButton: "प्रीमियम में अपग्रेड करें",
          reactivateButton: "सदस्यता पुनः सक्रिय करें",
          endsOn: "समाप्त होने की तारीख",
          cancelledNote: "आपकी सदस्यता रद्द कर दी गई है और यह समाप्त होगी",
          reactivateSuccess: "सदस्यता पुनः सक्रिय",
          reactivateSuccessDescription: "आपकी सदस्यता सफलतापूर्वक पुनः सक्रिय कर दी गई है।",
          reactivateError: "पुनः सक्रियकरण असफल",
          reactivateErrorDescription: "हम आपकी सदस्यता पुनः सक्रिय नहीं कर सके। कृपया फिर से प्रयास करें या सहायता से संपर्क करें।",
          cancelSuccess: "सदस्यता रद्द",
          cancelSuccessDescription: "आपकी सदस्यता वर्तमान बिलिंग अवधि के अंत में रद्द हो जाएगी।",
          cancelError: "रद्दीकरण असफल",
          cancelErrorDescription: "हम आपकी सदस्यता रद्द नहीं कर सके। कृपया फिर से प्रयास करें या सहायता से संपर्क करें।",
          cancelDialog: {
            title: "सदस्यता रद्द करें",
            description: "क्या आप वाकई अपनी सदस्यता रद्द करना चाहते हैं? आपकी वर्तमान बिलिंग अवधि के अंत तक आपकी पहुंच बनी रहेगी।",
            confirm: "हां, सदस्यता रद्द करें",
          },
        },
        billing: {
          title: "बिलिंग जानकारी",
          description: "अपनी बिलिंग विवरण और भुगतान विधियों का प्रबंधन करें",
          activeSubscription: "आपकी एक सक्रिय सदस्यता है। बिलिंग Stripe के माध्यम से सुरक्षित रूप से संभाली जाती है।",
          noActiveSubscription: "आपकी कोई सक्रिय सदस्यता नहीं है। प्रीमियम सुविधाओं तक पहुंचने के लिए अपग्रेड करें।",
        },
        security: {
          title: "सुरक्षा",
          changePassword: "पासवर्ड बदलें",
          changePasswordDescription: "अपने खाते का पासवर्ड अपडेट करें",
          changePasswordModal: {
            title: "पासवर्ड बदलें",
            currentPassword: "वर्तमान पासवर्ड",
            newPassword: "नया पासवर्ड",
            confirmPassword: "नया पासवर्ड पुष्टि करें",
            cancel: "रद्द करें",
            change: "पासवर्ड बदलें",
            success: "पासवर्ड बदला गया",
            successDescription: "आपका पासवर्ड सफलतापूर्वक बदल दिया गया है।",
            error: "परिवर्तन असफल",
            passwordsDontMatch: "नए पासवर्ड मेल नहीं खाते",
            weakPassword: "पासवर्ड कम से कम 6 अक्षर का होना चाहिए",
            incorrectPassword: "वर्तमान पासवर्ड गलत है",
          },
        },
      },
    },
    protected: {
      loginRequired: "साइन इन आवश्यक",
      loginMessage: "कृपया इस प्रीमियम कंटेंट तक पहुंचने के लिए साइन इन करें",
      subscriptionRequired: "प्रीमियम सब्सक्रिप्शन आवश्यक",
      subscriptionMessage:
        "एक्सक्लूसिव कंटेंट और एडवांस फीचर्स के लिए प्रीमियम में अपग्रेड करें",
      emailVerificationRequired: "ईमेल सत्यापन आवश्यक",
    },
  },
};